import React from 'react';
import { Input, Select, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Option } = Select;

/**
 * Shared filter bar for the Selection_Wizard's three steps — search plus an
 * optional Type filter. The Products step gets a Type filter (Standard/
 * Custom) and the Services step gets one too (Decoration/Charge), each
 * passed via `typeOptions`; Logistics provides neither. None of the three
 * steps filter by Status anymore — every catalog entry offered here is
 * already something the wizard considers selectable.
 */
export default function WizardStepFilters({
  t,
  search,
  onSearchChange,
  searchPlaceholder,
  typeFilter = 'all',
  onTypeFilterChange,
  typeOptions,
}) {
  return (
    <Space wrap size={12} style={{ marginBottom: 16 }}>
      <Input
        prefix={<SearchOutlined />}
        placeholder={searchPlaceholder}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        allowClear
        style={{ width: 260 }}
      />
      {typeOptions && (
        <Select value={typeFilter} onChange={onTypeFilterChange} style={{ width: 160 }}>
          <Option value="all">{t('All types')}</Option>
          {typeOptions.map(({ value, label }) => (
            <Option key={value} value={value}>{t(label)}</Option>
          ))}
        </Select>
      )}
    </Space>
  );
}
